import { Event } from '@sentry/vue'

import { FEDERATED_DSN } from '../common'
import { extractFederatedAppMeta } from '../utils'

export const addFederatedInfo = (event: Event) => {
  const federatedAppInfo = extractFederatedAppMeta(event)
  if (federatedAppInfo) {

    if (federatedAppInfo?.length) {
      event.extra = {
        ...event.extra,
        [FEDERATED_DSN]: federatedAppInfo,
      }

      event.tags = {
        ...event.tags,
        federated: 'true',
        federated_module: federatedAppInfo?.[0].module,
      }
    }
  }

  return event
}
